export const testimonials = [
  {
    topic: 'Understanding Root Movement',
    quote:
      'I used to look at the aligner simulation and assume the root would simply follow the crown. Volume I changed that completely. Now I check the center of resistance and the moment-to-force ratio before approving any anterior torque. My refinements on upper incisors have dropped noticeably.',
    name: 'Dr. Mateo Vargas',
    role: 'Orthodontist — Mexico',
    photo: 'https://cdn.magicpatterns.com/patterns/generated-images/c87064bb-daaf-459f-b6e4-b430c2d00e05.jpg',
  },
  {
    topic: 'Clinical Planning',
    quote:
      'The 5-step framework is now printed next to my monitor. Identify, analyze, select, verify, document — it keeps me from skipping steps when the schedule is full.',
    name: 'Dr. Camila Rojas',
    role: 'General Dentist — Chile',
    photo: 'https://cdn.magicpatterns.com/patterns/generated-images/93ff4f43-d154-4aaa-9aa6-63112aace76d.jpg',
  },
  {
    topic: 'Biomechanics',
    quote:
      'After 20 years of practice I didn’t expect to learn much, but the force-system chapter explained why some of my retraction cases lost torque. Clear, direct, and clinically useful.',
    name: 'Dr. Javier Morales',
    role: 'Orthodontist — Spain',
    photo: 'https://cdn.magicpatterns.com/patterns/generated-images/856c33de-cfea-4f4c-9911-4ab788686176.jpg',
  },
  {
    topic: 'Visual Resources',
    quote:
      'The Root Movement Visual Atlas is gold. Seeing tipping, translation and torque side by side made concepts click that I had struggled with during my residency.',
    name: 'Dr. Lucía Fernández',
    role: 'Orthodontic Resident — Argentina',
    photo: 'https://cdn.magicpatterns.com/patterns/generated-images/447e5dcf-09f6-481c-b296-f979af99fe4e.jpg',
  },
  {
    topic: 'Practical Application',
    quote:
      'I use the Torque Tracking Workbook at every follow-up. Comparing planned versus observed movement helped me catch a tracking problem early instead of discovering it at the end.',
    name: 'Dr. Patricia Herrera',
    role: 'Orthodontist — Colombia',
    photo: 'https://cdn.magicpatterns.com/patterns/generated-images/97a52169-421f-4c95-a73d-92ce1116a6f1.jpg',
  },
];
